<!-- Contenedor principal -->
<div class="d-flex" style="height: 60vh;">
	<!-- Zona principal (Encabezado + Terminal + Prompt) -->
	<div
		class="card bg-dark text-white shadow flex-grow-1 d-flex flex-column me-2"
	>
		<!-- 🔹 Encabezado superior con nombre o título -->
		<div
  class="p-2 d-flex align-items-center"
  style="
    background-color: #0f0f0f;
    border-bottom: 1px solid #333;
    font-weight: 600;
    letter-spacing: 0.5px;
  "
>

  <!-- Espacio izquierdo -->
  <div style="flex:1"></div>

  <!-- Centro: indicador + texto -->
  <div class="d-flex align-items-center justify-content-center gap-2" style="flex:1">

    <!-- Indicador -->
    <span
      [ngStyle]="{
        'background-color': isConnected ? '#28a745' : '#6c757d'
      }"
      style="
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        box-shadow: 0 0 4px rgba(0,0,0,0.5);
      "
    ></span>

    <!-- Texto -->
    <span>{{ headerText }}</span>

  </div>

  <!-- Derecha: botón -->
  <div style="flex:1; text-align:right">
    <button
      class="btn btn-sm btn-primary"
      (click)="reconect()"
      [disabled]="is_user_connect"
    >
      Reconectar
    </button>
  </div>

</div>

		<!-- Cuerpo del "terminal" -->
		<div
			id="terminal"
			class="card-body font-monospace flex-grow-1"
			style="
				background-color: #1e1e1e;
				overflow-y: auto;
				display: flex;
				flex-direction: column-reverse;
				padding-bottom: 0.5rem;
			"
		>
			<!-- Los mensajes se insertarán aquí -->
		</div>

		<!-- Entrada de comando -->
		<div
			class="d-flex p-2 align-items-center"
			style="background-color: #1e1e1e; border-top: 1px solid #333"
		>
		<span
				[ngStyle]="{
					'background-color': is_user_connect ? '#28a745' : '#6c757d'
				}"
				style="
					display: inline-block;
					width: 12px;
					height: 12px;
					border-radius: 50%;
					margin-right: 5px;
					box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
				"
			>
		</span>
			<span class="text-success">{{ username }}@</span>:<span
				class="text-info"
				>~/Netride</span
			>$&nbsp;
		</div>
	</div>

	<!-- Columna derecha (configuración) -->
	<div
		class="d-flex flex-column align-items-stretch gap-2 p-2"
		style="
			width: 220px;
			background-color: #f8f9fa;
			border: 1px solid #ddd;
			border-radius: 4px;
			overflow-y: auto;
		"
	>
		<!-- Sección: Audio -->
		<div class="card shadow-sm">
			<div class="card-body p-2">
				<div class="fw-semibold text-muted small mb-2 text-center">
					Configuración de Audio
				</div>

				<label for="volume" class="form-label small mb-1"
					>Volumen (0–100)</label
				>
				<div class="d-flex align-items-center gap-2">
					<input
						id="volume"
						type="range"
						class="form-range flex-grow-1"
						[(ngModel)]="audioVolume"
						name="audioVolume"
						min="0"
						max="100"
						step="1"
						list="volume-marks"
						aria-label="Volumen de audio (0 a 100)"
						aria-valuemin="0"
						aria-valuemax="100"
						[attr.aria-valuenow]="audioVolume"
					/>
					<span
						class="badge bg-secondary"
						style="min-width: 42px; text-align: center"
					>
						{{ audioVolume ?? 0 }}
					</span>
				</div>

				<!-- Marcas del potenciómetro -->
				<datalist id="volume-marks">
					<option value="0" label="0"></option>
					<option value="25" label="25"></option>
					<option value="50" label="50"></option>
					<option value="75" label="75"></option>
					<option value="100" label="100"></option>
				</datalist>

				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="applyVolume(audioVolume)"
					[disabled]="
						audioVolume === null ||
						audioVolume === undefined ||
						audioVolume < 0 ||
						audioVolume > 100
					"
				>
					Aplicar volumen
				</button>
				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="sendcommand('GET_VOLUME', 'Solicitando volumen')"
					[disabled]="
						audioVolume === null ||
						audioVolume === undefined ||
						audioVolume < 0 ||
						audioVolume > 100
					"
				>
					Solicitar Volumen
				</button>
			</div>
		</div>

		<!-- Sección: Resolución -->
		<div class="card shadow-sm">
			<div class="card-body p-2">
				<div class="fw-semibold text-muted small mb-2 text-center">
					Configuración de Resolución de la evidencia
				</div>

				<div class="row g-2">
					<div class="col-6">
						<label for="width" class="form-label small mb-1"
							>Ancho (px)</label
						>
						<input
							id="width"
							type="number"
							class="form-control form-control-sm"
							[(ngModel)]="resWidth"
							name="resWidth"
							min="320"
							step="1"
							placeholder="Ej. 1920"
							aria-label="Ancho en pixeles"
						/>
					</div>
					<div class="col-6">
						<label for="height" class="form-label small mb-1"
							>Alto (px)</label
						>
						<input
							id="height"
							type="number"
							class="form-control form-control-sm"
							[(ngModel)]="resHeight"
							name="resHeight"
							min="240"
							step="1"
							placeholder="Ej. 1080"
							aria-label="Alto en pixeles"
						/>
					</div>
				</div>

				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="applyResolution(resWidth, resHeight)"
					[disabled]="
						!resWidth ||
						!resHeight ||
						resWidth < 320 ||
						resHeight < 240
					"
				>
					Aplicar resolución
				</button>
				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="sendcommand('GET_RES', 'Solicitando resolución')"
					[disabled]="
						audioVolume === null ||
						audioVolume === undefined ||
						audioVolume < 0 ||
						audioVolume > 100
					"
				>
					Solicitar Resolución
				</button>
			</div>
		</div>

		<!-- Sección: tiempo de captura de evidencia -->
		<div class="card shadow-sm">
			<div class="card-body p-2">
				<div class="fw-semibold text-muted small mb-2 text-center">
					Configuración de Tiempo de captura de evidencias
				</div>

				<label for="timeMinutes" class="form-label small mb-1">
					Tiempo (minutos)
				</label>

				<div class="d-flex align-items-center gap-2">
					<input
						id="timeMinutes"
						type="number"
						class="form-control form-control-sm flex-grow-1"
						[(ngModel)]="timeMinutes"
						name="timeMinutes"
						min="1"
						max="300"
						step="1"
						placeholder="Ej. 30"
						aria-label="Tiempo en minutos"
					/>
					<span
						class="badge bg-secondary"
						style="min-width: 60px; text-align: center"
					>
						{{ timeMinutes ?? 0 }} min
					</span>
				</div>

				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="applyTime(timeMinutes)"
					[disabled]="
						timeMinutes === null ||
						timeMinutes === undefined ||
						timeMinutes < 1
					"
				>
					Aplicar tiempo
				</button>

				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="sendcommand('GET_TIME_SHOOT', 'Solicitando tiempo de evidencias')"
				>
					Solicitar tiempo
				</button>
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-body p-2">
				<div class="fw-semibold text-muted small mb-2 text-center">
					Modo de captura de evidencia
				</div>

				<!-- Switch de selección -->
				<div class="d-flex flex-column align-items-center text-center">
					<div class="small text-muted mb-1">
						Seleccione el origen de la evidencia
					</div>

					<div class="d-flex align-items-center justify-content-center gap-2 mb-2">
						<span
							class="badge"
							[ngClass]="type_shoot ? 'bg-secondary' : 'bg-primary'"
							style="min-width: 80px;"
						>
							Pantalla
						</span>

						<p-inputSwitch
							[(ngModel)]="type_shoot"
							onLabel="Cámara"
							offLabel="Pantalla"
							name="typeShootSwitch"
						></p-inputSwitch>

						<span
							class="badge"
							[ngClass]="type_shoot ? 'bg-primary' : 'bg-secondary'"
							style="min-width: 80px;"
						>
							Cámara
						</span>
					</div>

					<!-- Mensaje dinámico explicando qué hace -->
					<div
						class="alert p-2 w-100 small text-start"
						[ngClass]="type_shoot ? 'alert-success' : 'alert-info'"
						style="font-size: 0.75rem;"
					>
						<div *ngIf="type_shoot === true">
							<i class="bi bi-camera-video me-1"></i>
							<strong>Modo cámara:</strong> las evidencias se
							obtendrán desde el módulo de cámara física.
						</div>

						<div *ngIf="type_shoot === false">
							<i class="bi bi-display me-1"></i>
							<strong>Modo pantalla:</strong> las evidencias serán
							capturas de pantalla del reproductor.
						</div>
					</div>
				</div>

				<!-- Botón para aplicar el modo -->
				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="applyTypeShoot(type_shoot)"
				>
					Aplicar modo de captura
				</button>

				<button
					class="btn btn-sm btn-primary w-100 mt-2"
					(click)="sendcommand('IS_TYPESHOOT', 'Solicitando modo de captura actual')"
				>
					Solicitar modo actual
				</button>
			</div>
		</div>
	</div>
</div>

<!-- Pie inferior (otros botones) -->
<div
	class="modal-footer d-flex flex-wrap justify-content-center gap-2"
	style="
		max-height: 150px;
		overflow-y: auto;
		overflow-x: hidden;
		background-color: #f8f9fa;
		border-top: 1px solid #ddd;
	"
>
	<button
		*ngFor="let item of actionsOther; trackBy: trackByLabel"
		class="btn btn-sm btn-outline-primary flex-fill text-nowrap"
		style="min-width: 110px; max-width: 180px; white-space: nowrap"
		(click)="sendcommand(item.command, item.msgDisplay)"
	>
		{{ item.label }}
	</button>
</div>
